import { IClaim } from "./claim";
import { MiproLoginBase } from "./mipro-login-base";
import { UserLogin } from "./user-login";

export class CurrentUserChangedData {
    constructor(
        public oldUser: MiproLoginBase,
        public currentUser: MiproLoginBase,
        public userClaims: IClaim[]
    ) {}

    get isLogin(): boolean {
        return this.oldUser == null && this.currentUser != null;
    }

    get isLogout(): boolean {
        return this.oldUser != null && this.currentUser == null;
    }

    get identityChanged(): boolean {
        return this.isLogin || this.isLogout || this.oldUser?.id !== this.currentUser?.id;
    }

    get rolesChanged(): boolean {
        return (
            this.isLogin ||
            this.isLogout ||
            CurrentUserChangedData.flatAccess(this.oldRoles) !== CurrentUserChangedData.flatAccess(this.currentRoles)
        );
    }

    get groupsChanged(): boolean {
        return (
            this.isLogin ||
            this.isLogout ||
            CurrentUserChangedData.flatAccess(this.oldGroups) !== CurrentUserChangedData.flatAccess(this.currentGroups)
        );
    }

    get permissionsChanged(): boolean {
        return (
            this.isLogin ||
            this.isLogout ||
            CurrentUserChangedData.flatAccess(this.oldPermissions) !== CurrentUserChangedData.flatAccess(this.currentPermissions)
        );
    }

    get currentOrganizationChanged(): boolean {
        return this.isLogin || this.isLogout || this.oldUser?.defaultOrganizationId != this.currentUser?.defaultOrganizationId;
    }

    get accessRightsChanged(): boolean {
        return this.rolesChanged || this.groupsChanged || this.permissionsChanged || this.currentOrganizationChanged;
    }

    private get oldRoles() {
        return (<UserLogin>this.oldUser)?.roles ?? [];
    }

    private get currentRoles() {
        return (<UserLogin>this.currentUser)?.roles ?? [];
    }

    private get oldGroups() {
        return (<UserLogin>this.oldUser)?.groups ?? [];
    }

    private get currentGroups() {
        return (<UserLogin>this.currentUser)?.groups ?? [];
    }

    private get oldPermissions() {
        return (<UserLogin>this.oldUser)?.permissions ?? [];
    }

    private get currentPermissions() {
        return (<UserLogin>this.currentUser)?.permissions ?? [];
    }

    private static flatAccess(access: { id: string }[]) {
        return access
            .map(x => x.id)
            .sort((a, b) => a.localeCompare(b))
            .join(",");
    }
}
